import { ScopeDocumentTypes } from "../constants/contract-enums";
import {
  deleteScopeItem,
  getAllScopeItems,
  storeScopeItem,
  updateScopeItem
} from "../api-helpers/api-settings";

export default {
  state: {
    isGettingAllScopeItems: false,
    allScopeItems: null,
    designSheets: null,
    additionalServices: null,
    scopeItems: null,
    changeOrderItems: null,
    isStoringScopeItem: false,
    isUpdatingScopeItem: false,
    isDeletingScopeItem: false
  },
  mutations: {
    setIsGettingAllScopeItems(state, bool) {
      state.isGettingScopeItems = bool;
    },
    setAllScopeItems(state, allScopeItems) {
      state.allScopeItems = allScopeItems;
    },
    setDesignSheets(state, designSheets) {
      state.designSheets = designSheets;
    },
    setAdditionalServices(state, additionalServices) {
      state.additionalServices = additionalServices;
    },
    setChangeOrderItems(state, changeOrderItems) {
      state.changeOrderItems = changeOrderItems;
    },
    setScopeItems(state, scopeItems) {
      state.scopeItems = scopeItems;
    },
    setIsStoringScopeItem(state, bool) {
      state.isStoringScopeItem = bool;
    },
    setIsUpdatingScopeItem(state, bool) {
      state.isUpdatingScopeItem = bool;
    },
    setIsDeletingScopeItem(state, bool) {
      state.isDeletingScopeItem = bool;
    }
  },
  actions: {
    async getAllScopeItems({ state, commit }) {
      let scopeItemsData;
      if (!state.isGettingScopeItems) {
        commit("setIsGettingAllScopeItems", true);

        const allScopeItems = await getAllScopeItems();
        const designSheets = allScopeItems.filter(
          item => item.type === ScopeDocumentTypes.DESIGN_SHEETS
        );
        const additionalServices = allScopeItems.filter(
          item => item.type === ScopeDocumentTypes.DESIGN_ADDITIONAL
        );
        const scopeItems = allScopeItems.filter(
          item => item.type === ScopeDocumentTypes.CONSTRUCTION
        );
        const changeOrders = allScopeItems.filter(
          item => item.type === ScopeDocumentTypes.CHANGE_ORDER
        );

        commit("setAllScopeItems", allScopeItems);
        commit("setDesignSheets", designSheets);
        commit("setAdditionalServices", additionalServices);
        commit("setScopeItems", scopeItems);
        commit("setChangeOrderItems", changeOrders);

        scopeItemsData = {
          all: allScopeItems,
          [ScopeDocumentTypes.DESIGN_SHEETS]: designSheets,
          [ScopeDocumentTypes.DESIGN_ADDITIONAL]: additionalServices,
          [ScopeDocumentTypes.CONSTRUCTION]: scopeItems,
          [ScopeDocumentTypes.CHANGE_ORDER]: changeOrders
        };

        commit("setIsGettingAllScopeItems", false);
      }
      return scopeItemsData;
    },
    async storeScopeItem({ commit, dispatch, state }, scopeItem) {
      let response;
      if (!state.isStoringScopeItem) {
        commit("setIsStoringScopeItem", true);

        response = await storeScopeItem(scopeItem);

        dispatch("handleApiResponse", {
          responseStatus: response,
          successText: "Scope Item stored successfully.",
          errorText: "An error occurred while attempting to store Scope Item.",
          afterSuccessFunction: () => {
            dispatch("getAllScopeItems");
            commit("resetCreateEditComponentParams");
          }
        });

        commit("setIsStoringScopeItem", false);
      }
      return response;
    },
    async updateScopeItem({ commit, dispatch, state }, scopeItem) {
      let response;
      if (!state.isUpdatingScopeItem) {
        commit("setIsUpdatingScopeItem", true);

        response = await updateScopeItem(scopeItem);

        dispatch("handleApiResponse", {
          responseStatus: response,
          successText: "Scope Item updated successfully.",
          errorText: "An error occurred while attempting to update Scope Item.",
          afterSuccessFunction: () => {
            dispatch("getAllScopeItems");
            commit("resetCreateEditComponentParams");
          }
        });

        commit("setIsUpdatingScopeItem", false);
      }
      return response;
    },
    async deleteScopeItem({ commit, state, dispatch }, scopeItem) {
      let response;
      if (!state.isDeletingScopeItem) {
        commit("setIsDeletingScopeItem", true);

        response = await deleteScopeItem(scopeItem);

        dispatch("handleApiResponse", {
          responseStatus: response,
          successText: "Scope Item deleted successfully.",
          errorText: "An error occurred while attempting to update Scope Item.",
          afterSuccessFunction: () => {
            dispatch("getAllScopeItems");
            commit("resetCreateEditComponentParams");
          }
        });

        commit("setIsDeletingScopeItem", false);
      }
      return response;
    }
  }
};
